module.exports = __webpack_public_path__ + "img/arbre.48842f48.jpg";